import { Controller } from "@hotwired/stimulus"
import { isSameOriginRedirect, isAllowedProviderUrl } from "../lib/sso_url_validation"

export default class extends Controller {
  connect() {
    this.handleSSOWindowMessage = this.handleSSOWindowMessage.bind(this)
    window.addEventListener("message", this.handleSSOWindowMessage)
  }

  disconnect() {
    window.removeEventListener("message", this.handleSSOWindowMessage)
  }

  async submit(event) {
    event.preventDefault()

    try {
      const response = await this.performSSORequest()
      const data = await this.parseResponse(response)
      this.handleSSOResponse(data)
    } catch (error) {
      this.handleError(error)
    }
  }

  async performSSORequest() {
    const form = this.element
    const formData = new FormData(form)

    return fetch(form.action, {
      method: form.method,
      headers: { "Accept": "application/json" },
      body: formData,
      credentials: "same-origin"
    })
  }

  async parseResponse(response) {
    if (!response.ok) {
      const errorText = await response.text()
      const error = new Error(errorText || "SSO request failed")
      error.status = response.status
      throw error
    }
    return response.json()
  }

  handleSSOResponse(data) {
    if (data.error || data.errors) {
      this.handleError(new Error(data.error || data.errors))
      return
    }

    if (data.url) {
      if (!isAllowedProviderUrl(data.url)) {
        this.handleError(new Error("Unsafe SSO URL"))
        return
      }

      window.open(data.url, "ssoPopup", "width=600,height=700")
      return
    }

    throw new Error("SSO URL not received from server")
  }

  handleError(error) {
    let message = "SSO login failed"
    if (error && error.message) {
      try {
        const parsed = JSON.parse(error.message)
        if (parsed.error) {
          message = parsed.error
        } else {
          message = error.message
        }
      } catch {
        message = error.message
      }
    }
    alert(message)
  }

  async handleSSOWindowMessage(event) {
    if (event.origin !== window.location.origin) return
    if (event.data?.ssoRedirectUrl) {
      if (!isSameOriginRedirect(event.data.ssoRedirectUrl)) {
        this.handleError(new Error("Unsafe SSO URL"))
        return
      }

      window.location.href = event.data.ssoRedirectUrl
    }
    if (event.data?.ssoError) {
      this.handleError(new Error(event.data.ssoError))
    }
  }
}
